<abp-modal
  class="userModal"
  [busy]="busy"
  [options]="{ size: 'xl' }"
  [visible]="visible"
  (disappear)="disappear.emit()"
  (visibleChange)="onVisibleChange($event)"
>
  <ng-template #abpHeader>
    <h3>
      {{ title | abpLocalization }}
    </h3>
  </ng-template>

  <ng-template #abpBody>
    <div class="row">
      <form
        *ngIf="form"
        [formGroup]="form"
        class="col-6"
        (ngSubmit)="onSaveClicked()"
        validateOnSubmit
      >
        <h4 class="mb-3">{{ 'AbpIdentity::UserInformations' | abpLocalization }}</h4>
        <div>
          <label class="form-label"
            >{{ 'AbpIdentity::Roles' | abpLocalization }} <span class="text-danger">*</span></label
          >
          <div
            *ngFor="let roleGroup of roleGroups; let i = index; trackBy: trackByFn"
            class="form-check mb-3"
          >
            <input
              type="radio"
              class="form-check-input"
              [id]="'roles-' + i"
              [disabled]="selected.id ? true : null"
              (change)="onRoleSelected($event, roles[i].name)"
              [checked]="selectedRole === roles[i].name"
            />
            <label class="form-check-label" [attr.for]="'roles-' + i">{{ roles[i].name }}</label>
          </div>

          <div class="form-check mb-3 py-3" *ngIf="isManager">
            <input
              type="checkbox"
              id="cost-centre-enabled"
              class="form-check-input"
              [ngModelOptions]="{ standalone: true }"
              [ngModel]="isCostCentre"
              (ngModelChange)="onIsCostCentreChange($event)"
            />
            <label class="form-check-label" for="cost-centre-enabled">{{
              'AdministrationService::CostCentreUser' | abpLocalization
            }}</label>
          </div>
          <div class="mb-3">
            <label class="form-label" for="inspected-by">
              {{ 'ServicingService::Staff' | abpLocalization }}
            </label>
            <input
              id="inspected-by"
              [value]="staffUser ? staffUser.firstName + ' ' + staffUser.lastName : ''"
              class="form-control"
              maxlength="64"
              readonly
            />
          </div>
          <div class="mb-3">
            <label class="form-label">
              {{ 'ServicingService::Signature' | abpLocalization }}
            </label>
            <div class="picture-preview mx-auto">
              <div
                [style.background-image]="
                  avatarUrl ? 'url(' + avatarUrl + ')' : 'url(assets/images/no-picture.jpg)'
                "
              ></div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label" for="user-name">
              {{ 'AbpIdentity::UserName' | abpLocalization }} <span class="text-danger">*</span>
            </label>
            <input
              id="user-name"
              type="text"
              class="form-control"
              formControlName="userName"
              autocomplete="username"
            />
          </div>

          <div class="mb-3" *ngIf="!selected.id">
            <label class="form-label" for="password">
              {{ 'AbpIdentity::Password' | abpLocalization }} <span class="text-danger">*</span>
            </label>
            <abp-password inputId="password" formControlName="password"></abp-password>
          </div>

          <div class="mb-3">
            <label class="form-label" for="name">
              {{ 'AbpIdentity::DisplayName:Name' | abpLocalization }}
              <span class="text-danger">*</span>
            </label>
            <input id="name" type="text" class="form-control" formControlName="name" />
          </div>

          <div class="mb-3">
            <label class="form-label" for="surname">
              {{ 'AbpIdentity::DisplayName:Surname' | abpLocalization }}
              <span class="text-danger">*</span>
            </label>
            <input id="surname" type="text" class="form-control" formControlName="surname" />
          </div>

          <div class="mb-3">
            <label class="form-label" for="email">
              {{ 'AbpIdentity::EmailAddress' | abpLocalization }} <span class="text-danger">*</span>
            </label>
            <input
              id="email"
              type="email"
              class="form-control"
              formControlName="email"
              autocomplete="email"
            />
          </div>

          <div class="mb-3">
            <label class="form-label" for="phone-number">
              {{ 'AbpIdentity::PhoneNumber' | abpLocalization }}
            </label>
            <input
              id="phone-number"
              type="text"
              class="form-control"
              formControlName="phoneNumber"
              autocomplete="tel"
            />
          </div>

          <div class="form-check mb-2">
            <input
              id="active-checkbox"
              type="checkbox"
              class="form-check-input"
              formControlName="isActive"
            />
            <label class="form-check-label" for="active-checkbox">
              {{ 'AbpIdentity::DisplayName:IsActive' | abpLocalization }}
            </label>
          </div>

          <div class="form-check mb-2" *ngIf="!selected.id">
            <input
              id="should-change-password-on-next-login"
              type="checkbox"
              class="form-check-input"
              formControlName="shouldChangePasswordOnNextLogin"
            />
            <label class="form-check-label" for="should-change-password-on-next-login">
              {{ 'AbpIdentity::DisplayName:ShouldChangePasswordOnNextLogin' | abpLocalization }}
            </label>
          </div>

          <div class="form-check mb-3">
            <input
              id="lockout-checkbox"
              type="checkbox"
              class="form-check-input"
              formControlName="lockoutEnabled"
            />
            <label class="form-check-label" for="lockout-checkbox">
              {{ 'AbpIdentity::DisplayName:LockoutEnabled' | abpLocalization }}
            </label>
          </div>

          <div class="col-12 col-sm-3">
            <div class="flex flex-col mb-3">
              <label class="form-label" for="asset-hours">
                {{ 'RegisterService::Notifications' | abpLocalization }}
              </label>
              <div class="flex gap-1">
                <div *ngFor="let key of notificationOptions" class="flex items-center gap-1">
                  <input
                    type="checkbox"
                    [id]="'note-' + key"
                    class="form-check-input"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="notificationSettings[key]"
                  />
                  <label [for]="'note-' + key" role="button" class="me-2 min-w-max">
                    {{ 'RegisterService::' + capitalizeFirstLetter(key) | abpLocalization }}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div>
            <label class="form-label">{{
              'AbpIdentity::OrganizationUnits' | abpLocalization
            }}</label>
            <abp-tree
              *ngIf="organization.nodes?.length; else noDataMessage"
              [checkStrictly]="true"
              [checkable]="true"
              [nodes]="organization.nodes"
              [isNodeSelected]="organization.selectFn"
              [(checkedKeys)]="organization.checkedKeys"
              [(expandedKeys)]="organization.expandedKeys"
            >
            </abp-tree>
            <ng-template #noDataMessage>
              <p class="text-muted">
                {{ 'AbpIdentity::NoOrganizationUnits' | abpLocalization }}
              </p>
            </ng-template>
          </div>
        </div>
      </form>
      <div class="col">
        <div class="row mb-3">
          <h4 class="mb-3">
            {{ 'AdministrationService::UserRestrictions' | abpLocalization }}
          </h4>

          <h5>
            {{
              (isCostCentre ? 'RegisterService::CostCentre' : 'RegisterService::Locations')
                | abpLocalization
            }}
          </h5>

          <app-cost-centre-tree
            *ngIf="isCostCentre; else locations"
            [isLoading]="busy"
            [data]="costCentres"
            [readonly]="true"
            [checkable]="true"
            [checkStrictly]="true"
            [checkedKeys]="checkedKeys"
            (checkedKeysChange)="onCheckedKeysChange($event)"
          />
          <ng-template #locations>
            <app-locations
              [isLoading]="modalBusy"
              [readonly]="true"
              [checkable]="true"
              [getAll]="true"
              [hideSelect]="true"
              [checkStrictly]="false"
              [isAllSelected]="true"
              [restrictedKeys]="restrictedKeys"
              (restrictedKeysChange)="onRestrictedKeysChange($event)"
              [selectedLocation]="selectedLocation"
              (selectedLocationChange)="onSelectedLocationChange($event)"
            >
            </app-locations>
          </ng-template>
        </div>
        <div class="row pt-1">
          <app-event-types
            [restrictedKeys]="restrictedEvents"
            (restrictedKeysChange)="onRestrictedEventsChange($event)"
          />
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #abpFooter>
    <button type="button" class="btn btn-secondary" abpClose>
      {{ 'AbpIdentity::Cancel' | abpLocalization }}
    </button>
    <abp-button iconClass="fa fa-check" (click)="onSaveClicked()" [disabled]="form?.invalid">{{
      'AbpUi::Save' | abpLocalization
    }}</abp-button>
  </ng-template>
</abp-modal>
